import BaseModelAPI from '../BaseModelAPI';

export default class AppliedToList extends BaseModelAPI {

	static entity = 'appliedtolist'
	static entityName = 'appliedto';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
